<template>
  <div>
    <slot name="activator" :open="open"></slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ title }}</h2>
      </template>
      <div class="add-option-slide-in__content">
        <p v-if="text">
          {{ text }}
        </p>
        <validation-observer ref="observer" tag="div">
          <oie-form-wrapper class="input-column__container" @submit="addOption">
            <validation-provider
              v-slot="{errors}"
              slim
              rules="required"
              mode="lazy">
              <oie-base-input v-model="newOption" :label-text="labelText" :error-messages="errors"></oie-base-input>
            </validation-provider>
            <oie-base-dropdown
              v-if="dropdownOptions && dropdownOptions.length > 0"
              v-model="selectedDropdownValue"
              :label-text="dropdownLabel"
              :options="dropdownOptions"
              :name="dropdownName || 'dropdown-option'"
              :use-filter-functionality="false">
            </oie-base-dropdown>
            <oie-action-wrapper>
              <template #left>
                <oie-base-action type="submit" size="large">
                  {{ confirmText || tStatic('confirm') }}
                </oie-base-action>
                <oie-base-action theme="skeleton" size="large" @click="setActiveSlideIn(null)">
                  {{ tStatic('genericClose') }}
                </oie-base-action>
              </template>
            </oie-action-wrapper>
          </oie-form-wrapper>
        </validation-observer>
      </div>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    initialValue: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    dropdownOptions: {
      type: Array,
      default: null
    },
    dropdownLabel: {
      type: String,
      default: ''
    },
    dropdownName: {
      type: String,
      default: ''
    },
    dropdownDefaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newOption: '',
      selectedDropdownValue: this.dropdownDefaultValue
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('add-option-')
    this.newOption = this.initialValue
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    open() {
      this.setActiveSlideIn(this.name)
    },
    async addOption() {
      const isValid = await this.$refs.observer.validate()
      if(!isValid) return
      if (this.dropdownOptions && this.dropdownOptions.length > 0) {
        this.$emit('add-option', this.newOption, this.selectedDropdownValue)
      } else {
        this.$emit('add-option', this.newOption)
      }
    }
  }
}
</script>

<style lang="scss">
.add-option-slide-in__content {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}
</style>
